import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit } from '@angular/core'
import { NotificationService } from '../../services/notification.service'
import { I18nService, LgType } from '../../services/prod/i18n.service'
import { ProducerService } from '../../services/producer.service'
import { UtilsService } from '../../services/utils.service'
import { AppType } from '../../types/app.type'
import { ProducerType } from '../../types/producer.type'
import { Nullable } from '../../types/utils.type'

@Component({
  selector: 'bmcore-producer-page-header',
  templateUrl: './bmcore-producer-page-header.component.html',
  styleUrls: ['./bmcore-producer-page-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreProducerPageHeaderComponent implements OnInit, OnChanges {
  @Input() producer: ProducerType
  @Input() userID: number
  @Input() appType: AppType

  lg: LgType

  followersCount: number
  btnFollowText = 'Following'

  newWallpaper: Nullable<string> = null

  pluralizedTotalBeats: string
  pluralizedTotalPlays: string
  pluralizedTotalFollowers: string

  constructor(
    private notificationService: NotificationService,
    private i18nService: I18nService,
    private producerService: ProducerService,
    protected utilsService: UtilsService
  ) {
    this.lg = this.i18nService.getLanguageForPage()
  }

  ngOnInit(): void {
    this.btnFollowText = this.lg.producerPage.button.following
  }

  ngOnChanges() {
    this.followersCount = this.producer?.followersCount

    this.pluralizeTotalBeats()
    this.pluralizeTotalPlays()
    this.pluralizeTotalFollowers()
  }

  selectFileHandler(e: Event) {
    const input = e.target as HTMLInputElement
    if (!input.files?.length) {
      return
    }
    return input.files[0]
  }

  uploadAvatar(e: Event) {
    const resetCacheValue = 1
    const file = this.selectFileHandler(e)
    this.producerService.uploadAvatar(file).subscribe(
      res => {
        this.notificationService.handleSuccess(this.lg.producerPage.notifications.uploadAvatar)
        this.producerService.producer.next({
          ...this.producer,
          images: {
            ...this.producer.images,
            original: res.data.url,
            thumbnail: res.data.urlSmall + resetCacheValue
          }
        })
      },
      error => {
        this.notificationService.handleError(error.message)
      }
    )
  }

  uploadWallpaper(e: Event) {
    const file = this.selectFileHandler(e)
    this.producerService.uploadWallpaper(file).subscribe(
      res => {
        this.newWallpaper = res.data.url
        this.notificationService.handleSuccess(this.lg.producerPage.notifications.uploadWallpaper)
      },
      error => {
        this.notificationService.handleError(error.message)
      }
    )
  }

  pluralizeTotalBeats() {
    this.pluralizedTotalBeats = this.lg.pluralizeBeats({
      count: this.producer?.totalBeatsCount,
      isTotalBeatsCount: true
    })
  }

  pluralizeTotalPlays() {
    this.pluralizedTotalPlays = this.lg.pluralizeTotalPlays(Number(this.producer?.totalPlays))
  }

  pluralizeTotalFollowers() {
    this.pluralizedTotalFollowers = this.lg.pluralizeTotalFollowers(this.followersCount)
  }
}
